<template>
    <input
        type="text"
        :value="value"
        @input="onInput"
    >
</template>

<script lang="ts" setup>
defineProps<{
  value?: string | number
}>();

const modelValue = defineModel();
const onInput = (e: Event) => {
  modelValue.value = e.target?.value;
};
</script>
